import React, { useState } from "react";
import Container from "@mui/material/Container";
import { Box } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import "./SideNavBar.css";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import DirectionsRunOutlinedIcon from "@mui/icons-material/DirectionsRunOutlined";
import SelfImprovementOutlinedIcon from "@mui/icons-material/SelfImprovementOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ContactsIcon from "@mui/icons-material/Contacts";

const SideNavBar = ({ color }) => {
  const { hash } = useLocation();
  const [controlNav, setControlNav] = useState(false);

  return (
    <Container>
      <Box className="openMobileMenu">
        <MenuOutlinedIcon
          onClick={() => setControlNav(!controlNav)}
          className={color === "dark" ? "iconDark" : "iconLight"}
        />
      </Box>
      <Box className={!controlNav ? "navContainer" : ""}>
        <Box
          className={hash === "#home" ? "singleIconBoxActive" : "singleIconBox"}
        >
          <Link to="/#home">
            <HomeOutlinedIcon
              className={color === "dark" ? "iconDark" : "iconLight"}
            />
          </Link>
        </Box>
        <Box
          className={
            hash === "#about" ? "singleIconBoxActive" : "singleIconBox"
          }
        >
          <Link to="/#about">
            <PersonOutlineOutlinedIcon
              className={color === "dark" ? "iconDark" : "iconLight"}
            />
          </Link>
        </Box>
        <Box
          className={
            hash === "#skills" ? "singleIconBoxActive" : "singleIconBox"
          }
        >
          <Link to="/#skills">
            <DirectionsRunOutlinedIcon
              className={color === "dark" ? "iconDark" : "iconLight"}
            />
          </Link>
        </Box>
        <Box
          className={
            hash === "#project" ? "singleIconBoxActive" : "singleIconBox"
          }
        >
          <Link to="/#project">
            <SelfImprovementOutlinedIcon
              className={color === "dark" ? "iconDark" : "iconLight"}
            />
          </Link>
        </Box>
        <Box
          className={
            hash === "#contact" ? "singleIconBoxActive" : "singleIconBox"
          }
        >
          <Link to="/#contact">
            <ContactsIcon
              className={color === "dark" ? "iconDark" : "iconLight"}
            />
          </Link>
        </Box>
      </Box>
    </Container>
  );
};

export default SideNavBar;
